import * as React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { translate } from 'secullum-i18n';
import {
  Button,
  Card,
  Message,
  Space,
  Text,
  isTablet
} from 'secullum-react-native-ui';
import Link from '../../components/Link';
import Api from '../../modules/api';
import { getTheme } from '../../modules/layout';

interface Props {
  onSolicitarFerias: () => void;
  onVenderFerias: () => void;
  onAbrirSolicitacoes: () => void;
  onErroConexao?: (mensagem: string, onTentarNovamente: () => void) => void;
}

interface State {
  saldo: number | null;
  carregando: boolean;
  erroGeral: string;
}

class CardFerias extends React.Component<Props, State> {
  state: State = {
    saldo: null,
    carregando: true,
    erroGeral: ''
  };

  componentDidMount() {
    this.carregarSaldo();
  }

  carregarSaldo = () => {
    const api = new Api();

    this.setState({ carregando: true });

    api.getSaldoFerias({
      onSuccess: resposta => {
        this.setState({ saldo: resposta.saldo, carregando: false });
      },
      onError: err => {
        this.setState({ carregando: false });

        if (err.name === 'TimeoutError' && this.props.onErroConexao) {
          this.props.onErroConexao(err.message, this.carregarSaldo);
        } else {
          this.setState({ erroGeral: err.message });
        }
      }
    });
  };

  getCorSaldo = (saldo: number | null) => {
    // Saldo positivo é exibido em verde, negativo em vermelho e zero na cor padrão.
    if (saldo == null || saldo === 0) {
      return theme.textColor3;
    }

    return saldo > 0 ? theme.successColor : theme.errorColor;
  };

  renderSaldo = () => {
    const { saldo, carregando } = this.state;

    if (carregando || saldo == null) {
      return (
        <Text style={styles.saldoValor} nativeID="ferias-saldo">
          {'...'}
        </Text>
      );
    }

    const corSaldo = this.getCorSaldo(saldo);

    return (
      <>
        <View style={styles.saldoContainer}>
          <Text
            style={[
              styles.saldoSinal,
              { color: corSaldo },
              saldo >= 0 && styles.saldoSinalInvisivel
            ]}
          >
            {'-'}
          </Text>
          <Text
            style={[styles.saldoValor, { color: corSaldo }]}
            nativeID="ferias-saldo"
          >
            {Math.abs(saldo)}
          </Text>
          {/* Espelha o sinal da esquerda para o número não sair do centro. */}
          <Text style={[styles.saldoSinal, styles.saldoSinalInvisivel]}>
            {'-'}
          </Text>
        </View>
        <Text style={styles.saldoLabel} nativeID="ferias-saldo-label">
          {translate('dias')}
        </Text>
      </>
    );
  };

  render() {
    const { erroGeral } = this.state;
    const { onSolicitarFerias, onVenderFerias, onAbrirSolicitacoes } =
      this.props;

    return (
      <>
        <Card>
          <Card.Header
            nativeID="ferias-titulo"
            title={translate('Saldo Disponível')}
            titleStyle={styles.tituloHeader}
          />
          <Card.Section>
            <View style={Platform.OS === 'web' && styles.centralizeView}>
              {this.renderSaldo()}
              <Space />
              <Button
                nativeID="ferias-solicitar"
                text={translate('Solicitar Férias')}
                onPress={onSolicitarFerias}
              />
              <Space />
              <Button
                nativeID="ferias-vender"
                text={translate('Vender Férias')}
                onPress={onVenderFerias}
              />
              <Space height={32} />
              <Link
                nativeID="ferias-minhas-solicitacoes"
                style={styles.minhasSolicitacoesLink}
                text={translate('Minhas Solicitações')}
                onPress={onAbrirSolicitacoes}
              />
            </View>
          </Card.Section>
        </Card>
        <Message
          nativeID="ferias-mensagem-erro"
          type="warning"
          message={erroGeral}
          visible={erroGeral !== ''}
          onRequestClose={() => this.setState({ erroGeral: '' })}
        />
      </>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  tituloHeader: {
    textAlign: 'center'
  },
  saldoContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 8
  },
  saldoValor: {
    fontSize: isTablet() ? 56 : 48,
    fontWeight: 'bold',
    color: theme.textColor3,
    textAlign: 'center'
  },
  saldoSinal: {
    fontSize: isTablet() ? 56 : 48,
    fontWeight: 'bold',
    color: theme.textColor3
  },
  saldoSinalInvisivel: {
    opacity: 0
  },
  saldoLabel: {
    fontSize: isTablet() ? 20 : 16,
    color: theme.textColor3,
    textAlign: 'center'
  },
  minhasSolicitacoesLink: {
    textAlign: 'center'
  },
  centralizeView: {
    margin: 'auto',
    maxWidth: 350,
    width: '100%'
  }
});

export default CardFerias;
